import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../../Common/PlaceholderWrapper";
import PopupWrapper from "../../../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";

class CreateScheduleChangeRequest extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditForm: false
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize({}, {
                newItem: true, withParams: true, refresh: false
            }));
        } catch (e) {
            console.error(e);
        }
    };

    save = async () => {
        await this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItemParams));
        if (!this.props.dataItem.isError) {
            this.props.onCreated({VacancyCmdChTabCalIntId: this.props.dataItem.getField(0, "VacancyCmdChTabCalIntId")});
            this.props.onClose();
        }
    };

    paramRender = (h) => {
        return (<>
                <div className="row">
                    <div className="col-md-4">
                        {h.lbl("IsCommonCmd")}
                    </div>
                    <div className="col-md-4">
                        {h.ed("IsCommonCmd")}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        {h.lbl("TypeTabCalChgReasonName")}
                    </div>
                    <div className="col-md-4">
                        {h.ed("TypeTabCalChgReasonName")}
                    </div>
                </div>
            </>);
    };

    renderButtons = () => {
        return (<div className="modal-footer text-right">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={this.save}>{i18next.t("CreateRequest")}</button>
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.props.onClose}>{i18next.t("Cancel_Noun")}</button>
            </div>);
    };

    render() {
        return (<>
                <PopupWrapper popupVisible={true} title={i18next.t("CreateScheduleChangeRequest_Title")}
                              instructionId="CreateScheduleChangeRequest"
                              onClose={this.props.onClose} renderButtons={this.renderButtons}>
                    <PlaceholderWrapper placeholderId="CreateScheduleChangeRequest_10" collapsed={false} showSplitterLine={false}
                                        showInstruction={false}
                                        canCollapse={false} showHeaderTitle={false}>
                        <ComplexParam dataItem={this.props.dataItemParams}
                                      showApplyButton={false} showSearchBar={false}
                                      renderParams={this.paramRender}
                        />
                    </PlaceholderWrapper>
                </PopupWrapper>
            </>);
    }
}

CreateScheduleChangeRequest.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItemParams: PropTypes.object,
    onCreated: PropTypes.func,
    onClose: PropTypes.func
};

CreateScheduleChangeRequest.defaultProps = {
    onCreated: () => {
    }, onClose: () => {
    }
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.subScheduleChangeState.VacancyCmdChTabCal_PO_Add,
        dataItemParams: state.subScheduleChangeState.VacancyCmdChTabCal_PO_Add_Params
    }
}

export default connect(mapStateToProps)(CreateScheduleChangeRequest);